import z from 'zod';

const MAX_FILE_SIZE = 1024 * 1024 * 10;

const ACCEPTED_FILE_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  'image/png',
  'image/jpeg',
];

export const LOGO_FILE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];

export enum Order {
  ASC = 'asc',
  DESC = 'desc',
}

export enum StatusFilter {
  ACTIVE = 'filter-active',
  ALL = 'filter-all',
  INACTIVE = 'filter-inactive',
}

export const largeItemsToFetchMap = [5, 10, 20, 50, 100];

export const statusFilterTranslationKey: Record<StatusFilter, string> = {
  [StatusFilter.ALL]: 'All',
  [StatusFilter.ACTIVE]: 'Active',
  [StatusFilter.INACTIVE]: 'Inactive',
};

export const statusFilterMap = Object.keys(statusFilterTranslationKey);

export const zodFileSchema = ({
  fileMimeTypes = ACCEPTED_FILE_MIME_TYPES,
  maxFileSize = MAX_FILE_SIZE,
}: {
  fileMimeTypes?: string[];
  maxFileSize?: number;
} = {}) =>
  z.object({
    doc: z
      .union([
        z.instanceof(File),
        z.object({
          size: z.number(),
          type: z.string(),
          name: z.string(),
        }),
      ])
      .refine((record) => fileMimeTypes.includes(record?.type), 'File format is not supported')
      .refine((record) => record?.size <= maxFileSize, 'File size is too large'),
    docLink: z.string(),
    loadProgress: z.number().max(100),
    abort: z.function(),
    id: z.string(),
  });

export type ZodFileSchema = z.infer<ReturnType<typeof zodFileSchema>>;

export const urlSchemaWithoutProtocol = z.union([
  z.url().startsWith('https://', {
    message: 'URL format is incorrect',
  }),
  z.url().startsWith('http://', {
    message: 'URL format is incorrect',
  }),
  z.string().regex(new RegExp(/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/)),
]);
